export const getParentRoute = (route) => {
  if (!route) return null;
  let routeParts = route.split("/"); // e.g. /benchmark-skills/dashboard

  if (routeParts.length > 2) {
    routeParts.pop();
  }

  return routeParts.join("/");
};

export const getMenuState = (activeRoute) => {
  let bufferState = {};
  let parentRoute = getParentRoute(activeRoute);
  if (parentRoute) {
    bufferState[parentRoute] = true;
  }
  return bufferState;
};

export const isSelected = (selectedRoute, route) => {
  if (!route) return false;
  return selectedRoute == route;
};

export const isChildSelected = (selectedRoute, route) => {
  if (!route) return false;
  if (route.length > 2) {
    return selectedRoute.indexOf(route) >= 0;
  }
  return false;
};
